export const endSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
};

export const getFromSession = (key) => {
  const sessionObject = getSessionObject();
  return sessionObject[key];
};

export const validateSession = () => {
  return getFromSession("jwt") !== null || getFromSession("session") !== null;
};

export const getSessionObject = () => {
  const sessionKey = "session";
  const session =
    localStorage.getItem(sessionKey) || sessionStorage.getItem(sessionKey);
  if (typeof session === "string" && session !== "undefined") {
    return JSON.parse(session);
  }
  return {};
};

export const generatePrimaryKey = () => {
  const { SK } = getSessionObject();
  return SK;
};
